import React from 'react';
import { ProviderMatchProviderV9 } from '@kyruus/types';
import { FormattedMessage } from '@kyruus/intl';
import Link from '@kyruus/link';

import messages from '../../lib/messages';
import { ContactSection } from './styles';
import {
  trackingProfileContact,
  TrackingFunction
} from '../../lib/tracking-utils';
import { getProviderPhone } from '../../lib/utils';

interface ProfileContactProps {
  /** The provider whose name is displayed. */
  provider: ProviderMatchProviderV9;
  track: TrackingFunction;
}

const ProfileContact = ({
  provider,
  track
}: ProfileContactProps): React.ReactElement | null => {
  const phoneNumber = getProviderPhone(provider);
  const contactAnchor = (val: string): React.ReactElement => (
    <span key="phone" itemProp="telephone">
      <Link
        href={`tel:${val}`}
        onClick={() => trackingProfileContact(track, 'phone', provider.id)}
      >
        {val}
      </Link>
    </span>
  );

  // do not render component when neither phone nor request URL exists
  if (!phoneNumber) {
    return null;
  }

  return (
    <ContactSection data-testid="profile-contact">
      <FormattedMessage
        {...messages.profileContactWithPhoneOnly}
        values={{
          phone: phoneNumber && contactAnchor(phoneNumber)
        }}
      />
    </ContactSection>
  );
};

export default ProfileContact;
